import classNames from 'classnames';
import propTypes from 'prop-types';
import ReactLoading from 'react-loading';

const Loading = ({ type, color, height, width, center }) => (
    <div className="loading-wrapper">
        <ReactLoading type={type} color={color} height={height} width={width} className={classNames({"loading-center":center})} />
    </div>
);
export default Loading;

Loading.propTypes = {
    type: propTypes.string,
    color: propTypes.string,
    height: propTypes.number,
    width: propTypes.number,
    center: propTypes.bool    
}

Loading.defaultProps = {
    type: 'bars',
    color: '#159953',
    width: 64,
    height: 64,
    center: false
}
